import { Dialog, ModalProps } from '@mui/material'
import clsx from 'clsx'
import Icon from 'components/core-v2/atoms/Icon'
import { FC } from 'react'
import { ClassName } from 'types/props'

import classes from './modal.module.scss'

interface Props extends Omit<ModalProps, 'open' | 'children'>, ClassName {
  ['aria-labelledby']?: string
  isOpen: boolean
  width?: 'xs' | 'sm' | 'md' | 'lg'
}
const Wrapper: FC<Props> = ({ children, className, isOpen, onClose, width, ...props }) => (
  <Dialog
    PaperProps={{ className: classes.paper }}
    aria-labelledby={props['aria-labelledby']}
    className={clsx(classes.wrapper, classes[width], className)}
    open={isOpen}
    onClose={onClose}
    {...props}
  >
    {children}
  </Dialog>
)

interface HeaderProps {
  id: string
  onClose: () => void
}
const Header: FC<HeaderProps> = ({ children, id, onClose }) => (
  <div className={classes.header} id={id}>
    {children}
    <button className={clsx(classes.closeIcon, 'center')} type="button" onClick={onClose}>
      <Icon name="remove" />
    </button>
  </div>
)

const Body: FC<ClassName> = ({ children, className }) => (
  <div className={clsx(classes.body, className)}>{children}</div>
)

export interface BaseModalProps {
  isOpen: boolean
  onClose: () => void
}

export const Modal = {
  Wrapper,
  Header,
  Body
}
